import {graphql, StaticQuery} from 'gatsby';
import * as React from 'react'
import {AllImages} from './__generated__/AllImages';

const query=graphql`
    query AllImages {
      allFile {
        edges {
          node {
            name
            childrenImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `;

export type ImageProps = {
  allImages: AllImages;
}

export type ImageQueryProps = {
  render: (allImages: AllImages) => React.ReactNode;
}

export const QAllImages: React.FC<ImageQueryProps> = ({render}: ImageQueryProps) => {
  return <StaticQuery
    query={query}
    render={(data) => render(data)}/>;
};
